module.exports = __webpack_public_path__ + "media/team_photos/Mauer-Max-photo-5e6671da.webp";